import { Axios } from 'utils/AxiosConfig'

export const getTransactions = async (payload) => {
  const { data: response } = await Axios.get(`member/package-transaction`, payload)
  return response
}
export const getDetailTransactionById = async (id) => {
  const { data: response } = await Axios.get(`member/package-transaction/${id}`)
  return response
}
export const postManualSubscriptionApproval = async (payload) => {
  const { data: response } = await Axios.post(
    `member/profile/subscription/manual-subscription/approval`,
    payload
  )
  return response
}
